import { AutocompleteOption } from "components/Form/components/Autocomplete/Autocomplete";
import { MutableRefObject, useRef } from "react";
import CreatableSelect from "react-select/creatable";
import "../Autocomplete.scss";

interface AsyncSelectProps {
    menuRef: MutableRefObject<any>;
    selectedValue: any;
    dynamicOptions: AutocompleteOption[];
    loadOptions: (inputValue: string) => Promise<any>;
    handleMenuOpen: () => Promise<any>;
    currentPageRef: MutableRefObject<number>;
    setTerm: (term: string) => void;
    isSelectedOptionHidden: boolean;
    uniqueKey: string;
    restProps: any;
}

export const AsyncSelect = ({
    menuRef,
    selectedValue,
    dynamicOptions,
    loadOptions,
    handleMenuOpen,
    currentPageRef,
    setTerm,
    isSelectedOptionHidden,
    uniqueKey,
    ...restProps
}: AsyncSelectProps) => {
    const isClosingStateRef = useRef(false);

    return (
        <CreatableSelect
            ref={menuRef}
            key={uniqueKey}
            options={dynamicOptions}
            value={selectedValue}
            onMenuOpen={handleMenuOpen}
            onInputChange={(newValue, { action }) => {
                if (action === "input-change") {
                    currentPageRef.current = -1;
                    loadOptions(newValue);
                    if (newValue === "") {
                        setTerm("");
                    }
                } else if (action === "input-blur" || action === "set-value") {
                    // If the input is blurred, we need to clear the term
                    // so the next menu-close will not fetch
                    setTerm("");
                    currentPageRef.current = -1;
                    isClosingStateRef.current = true;
                } else if (action === "menu-close") {
                    if (isClosingStateRef.current) {
                        isClosingStateRef.current = false;
                    } else {
                        currentPageRef.current = -1;
                        loadOptions("");
                        setTerm("");
                    }
                }
            }}
            hideSelectedOptions={isSelectedOptionHidden}
            {...restProps}
        />
    );
};
